import { atualizarSituacaoVersao } from "login/actions";
import { exit, update } from 'platformImpl';
import { makeStyles } from "@material-ui/core";
import { useDispatch } from "react-redux";
import { useEffect } from "react";
import AppFooter from "shared/template/AppFooter";
import ilustracaoAtualizacaoRefresh from './assets/img/ilustracao-atualizacao-refresh.webp';

const DESCRICAO = "Atualize o aplicativo para continuar usando os serviços com segurança e facilidade."

const useStyles = makeStyles((theme) => ({
  titulo: {
    fontSize: "20.16px"
  },
  descricao: {
    fontSize: "16.8px"
  },
  imagem: {
    marginBottom: '32px'
  },
  root: {
    margin: '48px 16px 0px 16px',
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'column'
  },
}))

const SolicitarAtualizacao = ({ tipo }) => {

  const classes = useStyles();
  const dispatch = useDispatch();
  
  useEffect(() => {
    const originalStyle = window.getComputedStyle(document.body).overflow;
    document.body.style.overflow = 'hidden';

    return () => {
      document.body.style.overflow = originalStyle;
    };
  }, [])

  return (
    <>
      <div className={classes.root}>
        <div>
          <img 
            className={classes.imagem} 
            src={ilustracaoAtualizacaoRefresh} 
            alt="Pessoa segurando um smartphone com ícone de atualização na tela, representando o gesto de atualizar o aplicativo do Meu INSS." 
          />
        </div>

        <p className={classes.titulo}>
          Tem novidade no Meu INSS
        </p>

        <p className={classes.descricao}>{DESCRICAO}</p>
      </div>

      {tipo == 3 /* ATUALIZACAO FORCADA */ ? (
        <AppFooter
          textAlign="right"
          primaryText="Atualizar"
          primaryAction={() => update(exit)}
          secondaryText="Sair do Meu INSS"
          secondaryAction={exit}
        />
      ) : (
        <AppFooter
          textAlign="right"
          primaryText="Atualizar"
          primaryAction={() => { 
            update(); 
            dispatch(atualizarSituacaoVersao(0)); 
            sessionStorage.setItem('atualizacaoInformada', true); 
          }}
          secondaryText="Atualizar mais tarde"
          secondaryAction={() => { 
            dispatch(atualizarSituacaoVersao(0)); 
            sessionStorage.setItem('atualizacaoInformada', true); 
          }}
        />
      )}

    </>
  )
}

export default SolicitarAtualizacao;